import React from 'react';
import styled from 'styled-components';

import COLORS from 'constants/colors';
import Icon from 'components/elements/Icon';

// PLA-860: los completes se aplican en Atlas antes del cierre, pero NetSuite recien los conoce al
// cerrar la trilla. Este aviso se muestra mientras ese cierre este pendiente.
const Warning = styled.div`
  align-items: flex-start;
  display: flex;
  gap: 0.75rem;
  margin: 0 0 1rem;
  border-left: 4px solid ${COLORS.YELLOW};
  padding: 0.75rem 1rem;
  background: rgba(239, 212, 73, 0.15);

  p {
    margin: 0;
  }
`;

const Title = styled.p`
  font-weight: bold;
`;

export interface NetsuiteCloseWarningProps {
  showTitle?: boolean;
}

function NetsuiteCloseWarning({ showTitle = true }: NetsuiteCloseWarningProps) {
  return (
    <Warning role='alert' data-cy='netsuite_close_warning'>
      <Icon icon='info' color={COLORS.YELLOW} />

      <div>
        {showTitle && (
          <Title>{I18n.translate('milling_orders.netsuite_close_warning.title')}</Title>
        )}

        <p>{I18n.translate('milling_orders.netsuite_close_warning.body')}</p>
      </div>
    </Warning>
  );
}

export default NetsuiteCloseWarning;
